import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})

export class LoginComponent implements OnInit {
  model: any = {};
  error = false;
  loading = false;
  returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ){}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  onError(err) {
    this.loading = false;
    this.error = true;
  }

  login() {
    this.loading = true;

    this.authenticationService.login(this.model.username, this.model.password)
      .then(data => {
        this.loading = false;
        this.router.navigateByUrl(this.returnUrl);
      }, this.onError)
      .catch(this.onError.bind(this));
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts